module.exports = __webpack_public_path__ + "media/images/lb/152-893e4dd7932cb3a1270129c1a285494f.svg";